export enum TintDecision {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
